<div class="header-component">
  <div class="d-flex p-5 project-name">
    <div class="d-flex p-3">
      @if (validUser) {
        <span class="d-flex">
          <img
            nz-image
            nzSrc="assets/Chevron hallmark.png"
            alt="chevron logo"
            title="Chevron"
            class="chevron-logo ml-5"
            />
            <h2 class="ml-10 mb-0">
              <i>{{ facilityName }} {{ header.appTitle }}</i>
            </h2>
          </span>
        }
      </div>
      <div class="d-flex">
        <span>
          {{ header.welcome }} <b>{{ userFirstName }}</b>
        </span>
        <span
          nz-icon
          nzType="logout"
          nzTheme="outline"
          title="logout"
          class="ml-10 mr-15 cursor"
          (click)="logout()"
        ></span>
      </div>
    </div>

    <!-- header menus  -->
    @if (validUser) {
      <div class="header-menus" id="listOfMenus">
        @if (currentUrl !== '/') {
          <button
            type="button"
            class="btn back-btn"
            (click)="previousPage()"
            >
            <img src="./../../../assets/back-icon.png" />Back
          </button>
        }
        @for (list of menuLists; track list.name) {
          <ul nz-menu nzMode="horizontal" class="d-flex mr-15 pt-10">
            <li nz-submenu nzTitle="{{ list.name }}">
              <ul class="bg-color ul-list">
                @for (menu of list.menu; track menu.name) {
                  <li
                    nz-submenu
                    nzTitle="{{ menu.name }}"
                    [class.disabled]="menu.name === 'Facility' && disableNavigation"
                    >
                    <ul class="bg-color ul-list">
                      @for (subMenu of menu.subMenus; track subMenu.name) {
                        <li
                          nz-menu-item
                          (click)="openAction(menu.name, subMenu)"
                          [class.ant-menu-item-selected]="fac_Id === subMenu.fac_Id"
                          >
                          {{ subMenu.name }}
                        </li>
                      }
                    </ul>
                  </li>
                }
              </ul>
            </li>
          </ul>
        }
      </div>
    }
  </div>
